import cn from "classnames";
import React from "react";
import { ProgressBar } from "web-ui";

import type { ObjectiveProgress } from "../api/languageChallenge";
import imageAndroidLogo from "../images/android-logo.svg";
import xpIcon from "../images/xp-bolt-active.png";
import styles from "../styles/BonusChallengeDet.module.scss";
import xpStyles from "../styles/XpProgress.module.scss";
import { getEstimateXpPerDay } from "../util/challenges";

export interface Props {
  className?: string;
  androidObjective?: ObjectiveProgress;
  dueTimeSecondsSinceEpoch: number;
  userId: number;
}

/**
 * Shows the Bonus Challenge component for the Android Dogfooding challenge.
 */
const BonusChallengeAndroid = ({
  className,
  androidObjective,
  dueTimeSecondsSinceEpoch,
}: Props) => {
  const progressDenominator = androidObjective?.goal ?? 0;
  const progressNumerator =
    androidObjective && progressDenominator > 0
      ? Math.min(androidObjective.progress, progressDenominator)
      : 0;

  return (
    <div className={cn(styles.container, className)}>
      <div className={styles.header}>
        <img
          alt="Android Logo"
          className={styles["image-logo"]}
          height={30}
          src={imageAndroidLogo}
          width={30}
        />
        <h3 className={styles.heading}>Bonus: Duolingo Android Challenge</h3>
      </div>
      <div className={styles.content}>
        <span>
          Earn {androidObjective?.goal ?? "the required amount of"} XP on
          Android in any course during the learning challenge
        </span>
        <span className={styles.subtitle}>
          <p>Reward: $500</p>
        </span>
        {androidObjective ? (
          <>
            <div className={styles["progress-section"]}>
              <ProgressBar
                className={styles["progress-bar"]}
                denominator={progressDenominator}
                height={16}
                numerator={progressNumerator}
              />
              <div
                className={cn(
                  styles["progress-text"],
                  xpStyles["xp-container"],
                )}
              >
                {androidObjective.isComplete ? (
                  "Android XP objective completed!"
                ) : (
                  <>
                    <span className={xpStyles["xp-icon"]}>
                      <img alt="xp icon" height={20} src={xpIcon} width={15} />
                    </span>
                    <span className={xpStyles["xp-numerator"]}>
                      {androidObjective.progress}
                    </span>
                    <span className={styles["progress-separator"]}>
                      / {androidObjective.goal} XP
                    </span>
                  </>
                )}
              </div>
            </div>
            {!androidObjective.isComplete && (
              <div className={xpStyles["xp-text"]}>
                Earn{" "}
                <b>
                  {getEstimateXpPerDay(
                    dueTimeSecondsSinceEpoch * 1000,
                    androidObjective.goal - androidObjective.progress,
                  )}{" "}
                  XP per day
                </b>{" "}
                to complete the Android challenge
              </div>
            )}
          </>
        ) : null}
      </div>
    </div>
  );
};

export default BonusChallengeAndroid;
